import {
  CryptoCurrenciesForEnovipayPayout,
  CryptoCurrenciesForManualTransfer,
  CryptoCurrenciesForDfnsPayout,
} from '@bdswiss/common-enums'

const CRYPTO_NETWORK_OPTIONS = Object.values(CryptoCurrenciesForManualTransfer)

const CRYPTO_PAYOUT_NETWORK_OPTIONS = Object.values(CryptoCurrenciesForEnovipayPayout)

const CRYPTO_DFNS_PAYOUT_NETWORK_OPTIONS = Object.values(CryptoCurrenciesForDfnsPayout)

export {CRYPTO_NETWORK_OPTIONS, CRYPTO_PAYOUT_NETWORK_OPTIONS, CRYPTO_DFNS_PAYOUT_NETWORK_OPTIONS}
